// The fixed header has a second row a page can fill with its own navigation
// (the dashboard puts Overview / Cluster list there), so the brand and the
// page's tabs read as one header rather than a bar with tabs floating below.
//
// The header's height therefore varies by page. TopBar publishes it as the
// CSS variable --header-h; anything that sits under the header (the layout's
// spacer, the sidebar, sticky table heads) reads that instead of a constant.
import { createContext, useContext } from 'react';
import { tokens } from '../../styles/tokens';

export const HeaderSlotContext = createContext(null);

// the DOM node of the header's second row, or null before it mounts
export const useHeaderSlot = () => useContext(HeaderSlotContext);

const FALLBACK = tokens.sizes.topbarHeight + 1; // one row and its border

export const HEADER_H = `var(--header-h, ${FALLBACK}px)`;

// the same, as a number of pixels, for scroll arithmetic
export const headerHeight = () => {
  const v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h'));
  return Number.isFinite(v) ? v : FALLBACK;
};
